// utils/device.ts
let deviceIdPromise = null;

export function getDeviceId () {
  if (deviceIdPromise) return deviceIdPromise;

  deviceIdPromise = new Promise(resolve => {
    // Step 1：已有则直接返回（最快）
    const saved = localStorage.getItem('device_id');
    if (saved) return resolve(saved);

    // Step 2：等待 FingerprintJS 写入 localStorage（异步加载）
    const timer = setInterval(() => {
      const id = localStorage.getItem('device_id');
      if (id) {
        clearInterval(timer);
        resolve(id);
      }
    }, 80);
  });

  return deviceIdPromise;
}
